import SpecialityServices from './SpecialityServices'

export default SpecialityServices
